import React from 'react';
import ReactDOM from 'react-dom/client';


import 'semantic-ui-css/semantic.min.css';
import './assets/styles/main.scss'; 

import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 2 minutes — prevents redundant refetches
      // when navigating between pages/tabs within that window.
      staleTime: 2 * 60 * 1000,
      // Don't hammer the API just because the user alt-tabs back to the browser.
      refetchOnWindowFocus: false,
    },
  },
});


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
